import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ROUTES } from './menu-items';
import { LoanService } from '../../shared-component/service/loan/loan.service';
import { reduce } from 'lodash';

@Component({
  selector: 'ap-sidebar',
  styleUrls: ['./sidebar.component.scss'],
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {

  public menu: any = {};
  public showMenu: string = '';
  public showSubMenu: string = '';
  public sidebarnavItems: any[];
  public permissionItems: any[];
  public collectionOrg: any = 0;
  public dateRange: any = 0;
  public qrCode: any = null;

  @Output() myEvent = new EventEmitter();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loanService: LoanService
  ) {
  }

  ngOnInit() {
    this.menu = ROUTES;
    setTimeout( function(){
    window["pcodedmenu"].call();
    },100);

    // this.leadConnectorService.qrcode({}).subscribe( (res : any) =>{
    //   this.qrCode = res.data;
    // });

    this.googleTranslateElementInit();  
  }

  googleTranslateElementInit(){

    let oThat = this;
    var script = document.createElement('script');
    script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    script.classList.add("gmapScript");

    window["googleTranslateElementInit"] = function() {
      new window["google"].translate.TranslateElement({ pageLanguage: 'en',  includedLanguages : 'en,hi,gu,kn,te,ta'},'google_translate_element');
    };
    document.head.appendChild(script);
    
  }

  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }


  getLoans() {
    let params: any = {
      limit: 100,
      page: 1
    };

    // this.loanService.loanStatus(params).subscribe((res: any) => {
    //   this.loanList = res.data.reduce((acc, data) => {
    //     if (data.LoanEmis.find((LoanEmis) => (LoanEmis.status === 'Not Paid')
    //       || (LoanEmis.status === 'Partially Paid' && new Date() >= new Date(`${LoanEmis.dueDate}`)))) {
    //       acc.push(data);
    //     }
    //     return acc;
    //   }, []);
    // });
  }

  payNow() {
    // if (this.loanList.length > 1)
    //   this.router.navigateByUrl('/loans').then();
    // else if (this.loanList.length === 1)
    //   this.router.navigateByUrl(`/loans/payment/${this.loanList[0].id}`).then();
  }

  navigateToPath(path) {
    if(path)
      this.router.navigateByUrl(`${path}`).then();
  }
}
